import { render, staticRenderFns } from "./doctors-list.html?vue&type=template&id=5a93ea58&scoped=true&external"
import script from "./doctors-list.js?vue&type=script&lang=js&external"
export * from "./doctors-list.js?vue&type=script&lang=js&external"
import style0 from "./doctors-list.scss?vue&type=style&index=0&id=5a93ea58&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a93ea58",
  null
  
)

export default component.exports